export const PRODUCT_TEMPLATE_LIST_KEY = 'PRODUCT_TEMPLATE_LIST';
export const PRODUCT_TEMPLATE_ONE_KEY = 'PRODUCT_TEMPLATE_ONE';
